import CountUp from "react-countup";
import { RGN_TERM } from "../../constants/constants";
import styles from "./powerRank.module.scss"

export function BlockItem({ title, value, unit, img, rank }) {
	return (
		<div className={styles.item}>
			<div className={styles.item__img}>
				<img src={img} alt=""/>
			</div>
			<div className={styles.item__content}>
				<div className={styles.item__title}>{title}</div>
				<div className={styles.item__body}>
					<div>
						<span className={styles.item__value}>
							<CountUp end={value} separator="," duration={1.5} decimals={1} redraw={true} />
						</span>
						<span className={styles.item__unit}>{unit}</span>
					</div>
					<div>
						<span
							className={styles.item__rank}
							style={(() => {
								if(rank === 1) return { color: "#FFC943" };
								if(rank === 2) return { color: "#FFFFFF" };
								if(rank === 3) return { color: "#F79A4D" };
							})()}
						>{rank ?? "-"}</span>
						<span className={styles['item__rank-unit']}>위</span>
					</div>
				</div>
			</div>
		</div>
	);
}

export default function PowerRank({ data }) {
	const formattedData = data
		?.sort((a, b) => (b.monthPower + b.monthAddPower) - (a.monthPower + a.monthAddPower))
		?.slice(0, 3)
		?.map((item) => ({
			img: `/images/logos/${item.rgnCode}_logo.png`,
			rgnTerm: RGN_TERM[item.rgnCode],
			value: item.monthPower + item.monthAddPower,
		}))

	return (
		<div className={styles.block}>
			<div className={styles.block__head}>
				<div className={styles.block__title}>금월 발전량 TOP 3</div>				
			</div>

			<div className={styles.block__body}>
				{formattedData?.map((item, index) => (
					<BlockItem
						key={index}
						img={item.img}
						title={item.rgnTerm}
						value={item.value}
						unit='MWh'
						rank={index + 1}
					/>
				))}
			</div>
		</div>
	);
}